module.exports = __webpack_public_path__ + "static/media/logo-full.e44b8776.png";